import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

/** Centralised query keys keep cache invalidation predictable across modules. */
export const qk = {
  dashboard: ['dashboard'] as const,
  awsBilling: ['aws-billing'] as const,
  cleanupOverview: ['cleanup-overview'] as const,
  cleanupThresholds: ['cleanup-thresholds'] as const,
  stakeholders: (params?: unknown) => ['stakeholders', params] as const,
  stakeholder: (id: string) => ['stakeholder', id] as const,
  businesses: (params?: unknown) => ['businesses', params] as const,
  business: (id: string) => ['business', id] as const,
  skills: (params?: unknown) => ['skills', params] as const,
  organizations: (params?: unknown) => ['organizations', params] as const,
  opportunities: (params?: unknown) => ['opportunities', params] as const,
  opportunity: (id: string) => ['opportunity', id] as const,
  projects: (params?: unknown) => ['projects', params] as const,
  grievances: (params?: unknown) => ['grievances', params] as const,
  grievance: (id: string) => ['grievance', id] as const,
  meetings: (params?: unknown) => ['meetings', params] as const,
  meeting: (id: string) => ['meeting', id] as const,
  tasks: (params?: unknown) => ['tasks', params] as const,
  documents: (params?: unknown) => ['documents', params] as const,
  activities: (type: string, id: string) => ['activities', type, id] as const,
  notifications: ['notifications'] as const,
  tags: ['tags'] as const,
  departments: ['departments'] as const,
  department: (id: string) => ['department', id] as const,
  ministryParameters: (departmentId?: string) => ['ministry-parameters', departmentId] as const,
  ministryParameter: (id: string) => ['ministry-parameters', 'one', id] as const,
  roles: ['roles'] as const,
  users: (params?: unknown) => ['users', params] as const,
  search: (q: string) => ['search', q] as const,
}
